import invoke from "../invoke";
import {
  referralOptions,
  posBrands,
  communitySizeOptions,
  communityTypes
} from "../config";

export const SET_STEP = "SET_STEP";
export const UPDATE_ORGANIZATION = "UPDATE_ORGANIZATION";
export const UPDATE_PERSON = "UPDATE_PERSON";
export const SET_REFERRAL = "SET_REFERRAL";
export const SET_MESSAGE = "SET_MESSAGE";
export const SET_SUBMITTING = "SET_SUBMITTING";
export const SET_RESPONSE = "SET_RESPONSE";

export const setStep = step => ({
  type: SET_STEP,
  payload: step
});

export const updateOrganization = (key, value) => ({
  type: UPDATE_ORGANIZATION,
  payload: {
    key,
    value
  }
});

export const updatePerson = (
  key,
  value
) => ({
  type: UPDATE_PERSON,
  payload: {
    key,
    value
  }
});

export const setReferral = referral => ({
  type: SET_REFERRAL,
  payload: referral
});

export const setMessage = message => ({
  type: SET_MESSAGE,
  payload: message
});

const translate = (
  str,
  tKey
) => {
  const allTranslations = {
    posBrands,
    communitySizeOptions,
    referralOptions,
    communityTypes
  };

  const translation = allTranslations[tKey].find(
    ({ key }) => key === str
  );
  return (translation && translation.label) || "";
};

/**
 * This action creator submits our form to aws lambda for further processing.
 * It uses redux-thunk middleware to execute custom logic before creating the action object.
 */
export const submitForm = () => (dispatch, getState) => {
  dispatch({
    type: SET_SUBMITTING,
    payload: true
  });

  try {
    const leadData = getState();
    const sanitizedData = { ...leadData};
  
    if (leadData.organization.type === "club") {
      sanitizedData.organization = {
        name: leadData.organization.name,
        type: "Verein",
        size: translate(leadData.organization.size, "communitySizeOptions"),
        other_type: translate(leadData.organization.other_type, "communityTypes"),
        pos_brand: ""
      };
  
      sanitizedData.person.role = leadData.person.role;
    }

    if (leadData.organization.type === "fire") {
      sanitizedData.organization = {
        name: leadData.organization.name,
        type: "Feuerwehr",
        size: translate(leadData.organization.size, "communitySizeOptions"),
        other_type: "Feuerwehr",
        pos_brand: ""
      };
  
      sanitizedData.person.role = leadData.person.role;
    }
  
    if (leadData.organization.type === "pos") {
      sanitizedData.organization = {
        name: leadData.organization.name,
        type: "Markt / Verkaufsstelle",
        other_type: "",
        size: "",
        pos_brand: translate(leadData.organization.pos_brand, "posBrands")
      };
  
      sanitizedData.person.role = "";
    }
  
    if (leadData.organization.type === "brand") {
      sanitizedData.organization = {
        name: leadData.organization.name,
        type: "Partner",
        other_type: "",
        size: "",
        pos_brand: ""
      };
  
      sanitizedData.person.role = "";
    }
  
    sanitizedData.referral = translate(leadData.referral, "referralOptions");
  
    const translatedData = {
      default: leadData,
      sanitized: sanitizedData,
    };
  
    invoke(translatedData)
      .then(data => {
        dispatch({
          type: SET_SUBMITTING,
          payload: false
        });
        dispatch({
          type: SET_RESPONSE,
          payload: data
        });
      })
      .catch(err => {
        console.log(err);
        dispatch({
          type: SET_RESPONSE,
          payload: {
            error: true,
          },
        });
        __SENTRY__.hub.captureException(err);
      });
  } catch (err) {
    dispatch({
      type: SET_RESPONSE,
      payload: {
        error: true,
      },
    });
    __SENTRY__.hub.captureException(err);
  }
};
